import HttpClienteToken from '../../services/HttpClientToken';

import { PaginacionProps } from '../../interfaces/global/PaginacionInterface';

import { HttpResponse } from '../../interfaces/auth/AuthInterface';

import { AxiosError } from 'axios';

import { ControlarDispositivosParams, EnviarWhatsAppParams, GenerarCodigoAccesoParams, GenerarCodigoAccesoResponse, ObtenerDispositivosResponse, ObtenerGrupoAccesosResponse, VisualizarAccesoProps } from '../../interfaces/comun/AccesoInterface';

export const GenerarCodigoAcceso = ( params: GenerarCodigoAccesoParams ) => {

    return new Promise<GenerarCodigoAccesoResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Acceso/GenerarCodigoAcceso/', params, token)
            .then( ({ data } : { data : GenerarCodigoAccesoResponse } ) => {               
                resolve( data );                
            })
            .catch( ( error: AxiosError ) => {
                resolve( {
                    success: false,
                    message: error.message,
                    idAcceso: 0,
                    aplicacion: '',
                    estatus: '',
                    idEstatus: 0,
                    imagen: '',
                    referencia: '',  
                });
            });
        }

    });

}

export const VisualizarAccesos = ( params: PaginacionProps ) => {

    return new Promise<VisualizarAccesoProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Acceso/VisualizarAccesos/', params, token)
            .then( ({ data } : { data : VisualizarAccesoProps } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    pageCount: 0,
                    currentPageIndex: 0,
                    recordsCount: 0,
                    records: [],
                } );
            });
        }

    });

}

export const EnviarWhatsApp = ( params: EnviarWhatsAppParams ) => {

    return new Promise<HttpResponse>( (resolve, eject) => {   

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClienteToken.post('/Api/Acceso/EnviarWhatsApp', params, token )
            .then( ({ data } : { data : HttpResponse } ) => {                 
                resolve( data );                
            })
            .catch( ( error: AxiosError ) => {
                resolve( { success: false, message: error.message } );
            });      
    
        }

    });

}

export const ObtenerGrupoAccesos = () => {

    return new Promise<ObtenerGrupoAccesosResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClienteToken.get('/Api/Acceso/ObtenerGrupoAccesos/', token)
            .then( ({ data } : { data : ObtenerGrupoAccesosResponse } ) => {               
                resolve( data );                
            })
            .catch( ( error: AxiosError ) => {
                resolve( {
                    success: false,
                    message: error.message,
                    privilegeGroups: [],
                });
            });
            
        }

    });

}

export const ObtenerDispositivos = () => {

    return new Promise<ObtenerDispositivosResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClienteToken.get('/Api/Acceso/ObtenerDispositivos/', token)
            .then( ({ data } : { data : ObtenerDispositivosResponse } ) => {               
                resolve( data );                
            })
            .catch( ( error: AxiosError ) => {
                resolve( {
                    success: false,
                    message: error.message,
                    dispositivos: [],
                });
            });
            
        }

    });

}

export const ControlarDispositivos = ( params: ControlarDispositivosParams ) => {

    return new Promise<HttpResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClienteToken.post('/Api/Acceso/ControlarDispositivos/', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {               
                resolve( data );                
            })
            .catch( ( error: AxiosError ) => {
                resolve( {
                    success: false,
                    message: error.message,
                });
            });
            
        }

    });

}